module.exports = __webpack_public_path__ + "img/red_bg2.e8ebe590.png";